export default {
  getList: {
    method: 'post',
    url: '/company/group/list'
  },
  getAllGroup: {
    method: 'post',
    url: '/company/group/get-all'
  },
  addGroup: {
    method: 'post',
    url: 'company/group/create'
  },
  editGroup: {
    method: 'put',
    url: 'company/group/edit'
  },
  updatePermissions: {
    method: 'put',
    url: 'company/group/update-permission'
  },
  deleteGroup: {
    method: 'delete',
    url: 'company/group/delete'
  }
}
